export default __webpack_public_path__ + "static/media/oe-2-lqMAX.faa42f98.jpg";